<template>
    <div class="nft-item nft-show">
        <div
            id="nft-image-box"
            class="nft-image-box"
        >
            <Loading v-bind:isShow="!isLoaded" />
            <NftMask v-if="isLoaded && !isClicked" v-on:click="toggleStart" />
            <PlutoEffect
                ref="plutoEffectRef"
                v-bind:onParentFunc="onPlayHook"
                v-bind:onlyNft="true"
            />
            <div
                class="nft-image"
                v-on:click="toggleStart"
            >
                <div class="jsgif-box show">
                    <img
                        class="jsgif"
                        v-bind:src="nftImage"
                    >
                </div>
            </div>
            <div class="nft-control">
                <div class="btn-grp">
                    <button
                        v-for="item in synthMapDisplay.slice(0, 6)"
                        v-bind:key="item.idx"
                        v-bind:class="{'active': currentNote[item.key].find(n => item.keyCode === n)}"
                        v-on:click="play(item.key, item.idx, item.keyCode)"
                    >
                        <!-- v-on:click="play(item.idx)" -->
                        {{ item.name }}
                    </button>
                </div>
                <button
                    class="reset "
                    v-on:click="toggleStart"
                >
                    <span v-if="!isPlaying" class="gg-play-button" />
                    <span v-if="isPlaying" class="gg-play-stop" />
                </button>
                <div class="btn-grp">
                    <button
                        v-for="item in synthMapDisplay.slice(6, 12)"
                        v-bind:key="item.idx"
                        v-bind:class="{'active': currentNote[item.key].find(n => item.keyCode === n)}"
                        v-on:click="play(item.key, item.idx, item.keyCode)"
                    >
                        <!-- v-on:click="play(item.idx)" -->
                        {{ item.name }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {
        reactive,
        onMounted,
        onUnmounted,
        computed,
        ref,
        watch,
        nextTick,
    } from 'vue';
    import nftImage from '@/assets/images/demi/demi-nft.jpg';
    import Loading from '@/components/Loading.vue';
    import NftMask from '@/components/NftMask.vue';
    import PlutoEffect from '@/components/PlutoEffect.vue';

    import { GlobalStore } from '@/store/GlobalStore';
    import { throttle } from '@/utils/debounce';
    import { GrpType, SynthInfo, synthMap, useDemi } from '@/utils/useDemi';
    import { preloadImage } from '@/utils/utils';

    preloadImage(nftImage);

    const { screenSize } = GlobalStore;

    const MAX_SIZE = 500;
    const MIN_SIZE = 300;

    const onPlayHookList: Array<(key: string) => void> = [];
    const onPlayHook = (func: (key: string) => void) => {
        onPlayHookList.push(func);
        return () => {
            onPlayHookList.splice(onPlayHookList.indexOf(func), 1);
        };
    };

    function onPlay(key: string, index: number, keyMap: any) {
        onPlayHookList.forEach(func => func(`${key.toLowerCase()}${index}`));
    }
    const {
        isLoaded,
        init,
        play,
        toggleStart: _toggleStart,
        currentNote,
        isPlaying,
        keyMap,
    } = useDemi(onPlay);
    init();

    const isClicked = ref(false);

    const toggleStart = () => {
        isClicked.value = true;
        _toggleStart();
    };

    const synthMapDisplay = computed(() => {
        const arr: {
            key: GrpType,
            idx: number,
            keyCode: number,
            name: string
        }[] = [];
        Object.entries(keyMap).forEach((val) => {
            val[1].forEach((v, idx) => {
                arr.push({
                    key: val[0] as unknown as GrpType,
                    idx,
                    keyCode: v.k,
                    name: v.n, // v.idx as unknown as string,
                });
            });
        });
        return arr;
    });

    const resizeNft = throttle(_resizeNft, 500);
    onMounted(() => {
        window.addEventListener('resize', resizeNft);
        window.addEventListener('load', resizeNft);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', resizeNft);
        window.removeEventListener('load', resizeNft);
    });

    function _resizeNft() {
        // 1488 * 1237
        const rateH = Math.round((1237 / 1488) * 100) / 100;
        const { width, height } = screenSize.value;
        const size = Math.max(Math.min(width, height, MAX_SIZE), MIN_SIZE);
        const nftBox = document.getElementById('nft-image-box');
        if (nftBox) {
            nftBox.style.width = `${size}px`;
            nftBox.style.height = `${size * rateH}px`;
        }
    }

    function getNftBoxSize() {
        const nftBox = document.getElementById('nft-image-box');
        if (nftBox) {
            const { width, height } = nftBox.getBoundingClientRect();
            return { width, height };
        }
        return { width: MAX_SIZE, height: MAX_SIZE };
    }

</script>

<style lang="scss">
  @import '@/scss/foundation/config';;
  // .section-studio {}
  .nft-item .nft-control {
    z-index: 5;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    // flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0.2rem;
    // background-color: rgba(0, 0, 0, 0.5);
    .btn-grp {
      display: flex;
    flex-wrap: wrap;
    flex: 1 1 42%;
    }
     button {
       cursor: pointer;
      //  margin: 0 10px;
     }

       button {
         color: white;
         display: inline-block;
         position: relative;
         top: calc(50% - 1em);
         text-align: center;
         font-size: 1.28em;
         background: rgba(0, 0, 0, 0.1);
        //  border: 2px solid white;
         transition: all 0.32s ease-in-out;
         flex: 1 1 28%;
         margin: 2px;

          box-shadow: 0px 3px 3px rgba(0, 0, 0, .7);
          color: #4288c8;
          padding: 1px 5px;
          background: rgba(47, 51, 54, 0.7);
          border-radius: 12px;
          text-shadow: 0px 0px 40px #7192fe, 0px 0px 80px #719efe;
          // width: 25px;
          text-align: center;

          &.reset {
                box-sizing: border-box;
            position: relative;
            display: block;
            transform: scale(var(--ggs,1));
            padding: 5px 10px;
            width: 35px;
            height: 27px;
            flex: 0 0 35px;
            display: flex;
            justify-content: center;
            align-items: center;

            & > span {
              color: #4288c8;
              width: 10px;
              height: 10px;
              padding: 2px 5px;
            }
          }

          &:hover {
            color: #0084ff;
            background: rgba(47, 51, 54, 0.9);
            text-shadow: 1px 2px 60px #00BCD4, 0px 0px 60px rgba(0, 188, 212, .9), 0px 0px 60px rgba(0, 188, 212, .9), 10px 10px 60px rgba(0, 188, 212, .9);
            cursor: pointer
          }

          &.active {
            color: #bcbf00;
            background: rgba(66, 135, 200, 0.7);
          }
       }

       button span {
         display: inline-block;

         width: 100%;
         height: 100%;

         padding: 1ex;

         color: white;

         transition: color 0.32s ease-in-out;
       }

  }

  .nft-item {
    display: inline-block;
    width: 100%;
    height: 100%;
    max-width: 500px;
    max-height: 500px;
    // position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .nft-image-box {
      position: relative;
      transition: background-color 106ms ease-in;

      .nft-image {
        z-index: 1;
        // padding: 1rem;
        position: relative;
        width: 100%;
        height: 100%;
        .jsgif-box {
          visibility: hidden;
          &.show {
            visibility: initial;
          }
        }
        .jsgif {
          position: absolute;
          top: 0;
          left:0;
          width: 100%;
          height: 100%;
          canvas {
            width: 100%;
            height: 100%;
          }
        }

      }

      .nft-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }
      .keypad-box {
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        box-sizing: border-box;

      }
      .keypad-item {
        cursor: pointer;
        opacity: .5;
        background-color: rgb(243, 243, 243);
        // maxwidth: 95px;
        // height: 30px;
        padding: .1rem 1rem;
        display: inline-block;
        border: 2px solid black;
        box-shadow: inset -2px -2px 3px #656565;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        &:hover {
          opacity: 1;
        }
        .text {
          color: #222222;
          font-size: .7rem;
        }
      }
      .rec-item {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        box-sizing: border-box;
        background-color: rgb(243, 243, 243);
        width: 205px;
        height: 70px;
        border: 2px solid black;
        box-shadow: inset -2px -2px 3px #656565;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;

        span {
          display: inline-block;
        }

        .recdot {
          vertical-align: middle;
          width: 29px;
          height: 29px;
          border-radius: 100%;
          margin-right: 15px;
          border: 1px solid black;
          background-color: gray;
          margin-top: -5px;

          &.recording {
            background-color: rgba(219, 0, 0, 0);

            animation: bright-light 1200ms ease-out infinite alternate;
          }

        }

        .rectext {
          color: #222222;
          font-size: 44px;
        }
      }
    }

  }
.vdr-container{
  z-index: 10000;
  &.active {
        cursor: move;
        padding: 2px;
    .vdr-handle.handle {
          display: block!important;;
    }

  }
  &.disabled {
    border: none!important;
    .vdr-handle.handle {
          display: nont!important;;
    }
  }
}

@media only screen and (max-width: 460px) {
.nft-item .nft-image-box .rec-item {
    width: 185px;
    height: 63px;
    .rectext {
      font-size: 40px;
    }
    .recdot {
          width: 26px;
    height: 26px;
    margin-right: 11px;
    margin-top: -3px;
    }
}
}
@media only screen and (max-width: 410px) {
  .nft-item .nft-image-box .rec-item {
      width: 167px;
      height: 57px;
      .rectext {
        font-size: 35px;
      }
      .recdot {
            width: 23px;
      height: 23px;
      margin-right: 10px;
      margin-top: -3px;
      }
  }
}

img.gif {
  visibility: hidden;
}

.gifcontrol {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &:after {
    transition: background 0.25s ease-in-out;
    position: absolute;
    content: "";
    display: block;
    left: calc(50% - 25px);
    top: calc(50% - 25px);
  }

  &.loading {
    background: rgba(255, 255, 255, 0.75);
    &:after {
      background: #FF9900;
      width: 50px;
      height: 50px;
      border-radius: 50px;
    }
  }

  &.playing {
    /* Only show the 'stop' button on hover */
    &:after {
      opacity: 0;
      transition: opacity 0.25s ease-in-out;
      border-left: 20px solid #FF9900;
      border-right: 20px solid #FF9900;
      width: 50px;
      height: 50px;
      box-sizing: border-box;
    }
    &:hover:after {
      opacity: 1;
    }
  }

  &.paused {
    background: rgba(255, 255, 255, 0.5);
    &:after {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 25px 0 25px 50px;
      border-color: transparent transparent transparent #ff9900;
    }
  }

  transition: background 0.25s ease-in-out;
  z-index: 100;

}

@keyframes bling-bg {
  0% {
    background: rgb(255, 255, 80);
  }
  25% {
    background: rgb(75, 250, 125);
  }
  50% {
    background: rgb(63, 137, 255);
  }
  75% {
    background: rgb(181, 67, 246);
  }
}

.bling-bg {
  background: rgba(255, 255, 255, 0.5);
  animation: bling-bg 968ms ease-in-out infinite alternate;
}

</style>
